var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-switch',{staticClass:"my-2",attrs:{"label":_vm.schema.labelSwitch,"dense":"","hide-details":""},on:{"change":_vm.toggleAttributesInfo},model:{value:(_vm.enabled),callback:function ($$v) {_vm.enabled=$$v},expression:"enabled"}}),(_vm.enabled)?_c('DevContainerOfPanel',{attrs:{"schema":{
      type: 'devContainerOfPanel',
      model: _vm.schema.model,
      component: 'dev-simple-object-attr',
      styleClasses: 'col-12',
      title: _vm.schema.labelContainer
    },"model":{ [_vm.schema.model]: _vm.model[_vm.schema.model] }}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }